/* =========================================================
   Affiche ESCALADE — la topo, le carnet de croix, la progression, le bloc,
   la course.
   API : SNEsTopo.render(data, opts) -> string SVG
     data : { mode, titre, kicker, club, lieu, joueur, equipe,
              mode 'voie'        → p1..p8 (« 35|6b|Le dièdre ») : mètres, cotation, nom
              mode 'croix'       → c1..c8 (« La Rose et le Vampire|7b|À vue|Buoux »)
              mode 'progression' → r1..r10 (« 2019|6b ») : année, cotation
              mode 'bloc'        → cotation, essais, seances, spot, s1..s3
              mode 'course'      → globale, sommet, denivele, l1..l6 }
     opts : { palette }

   AUCUNE TABLE DE CONVERSION N'EST IMPRIMÉE, et c'est délibéré. Les
   correspondances français / YDS / UIAA se contredisent d'une source à
   l'autre — un 9a vaut 5.14d, pas 5.15a, et l'UIAA XI, pas XII+ — et un
   grimpeur repère l'erreur immédiatement. L'affiche n'utilise donc que
   L'ORDRE de l'échelle française, qui lui n'est pas contesté.

   La cotation de BLOC en France suit le même système que la voie (norme FFME
   de décembre 2023, de 1b à 8c) tandis que Fontainebleau écrit ses blocs en
   majuscules. Le moteur accepte les deux graphies sans trancher.

   Auto-suffisant (aucun fetch, aucune image, aucun aléa) → re-render serveur.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 64;

  const PALETTES = {
    calcaire: { label:'Calcaire', bg:'#F4F1EA', ink:'#2A2622', muted:'#8A8177', accent:'#C2410C', line:'#E0DACD', card:'#FFFFFF', roche:'#DED6C6' },
    granit:   { label:'Granit',   bg:'#23262B', ink:'#F1F2EE', muted:'#949AA3', accent:'#E8933D', line:'#383D45', card:'#2C3037', roche:'#3A3F47' },
    gres:     { label:'Grès',     bg:'#2E2119', ink:'#F5EDE3', muted:'#B09883', accent:'#E8A33D', line:'#4A362A', card:'#3A2B20', roche:'#4E3A2C' },
    nuit:     { label:'Nuit',     bg:'#0B2D5B', ink:'#F7F4ED', muted:'#93A1B8', accent:'#FF9E5C', line:'#1E4272', card:'#12355F', roche:'#173861' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fit = (t, maxW, maxS, cwf, ls, minS) => { const n = String(t).length || 1; minS = minS || 12;
    for (let s = maxS; s > minS; s -= 1) if (n * (cwf * s + ls) <= maxW) return s; return minS; };
  const T = (x,y,size,fill,txt,o) => { o = o || {};
    return `<text x="${x}" y="${y}" font-family="${o.f||'Sora'}" font-size="${size}" font-weight="${o.w||600}" fill="${fill}"`
      + (o.ls?` letter-spacing="${o.ls}"`:'') + ` text-anchor="${o.a||'middle'}"` + (o.op?` opacity="${o.op}"`:'') + `>${txt}</text>`; };

  /* L'ÉCHELLE FRANÇAISE, dans l'ordre. C'est la seule chose qu'on affirme :
     que 6b+ est plus dur que 6b et moins dur que 6c. Aucune équivalence avec
     une autre échelle n'est avancée nulle part. */
  const ECHELLE = ['3', '4a', '4b', '4c', '5a', '5b', '5c', '6a', '6a+', '6b', '6b+', '6c', '6c+',
    '7a', '7a+', '7b', '7b+', '7c', '7c+', '8a', '8a+', '8b', '8b+', '8c', '8c+', '9a', '9a+', '9b', '9b+', '9c'];
  /** « 6B+ », « 6 b + » ou « 6b+ » → l'indice dans ECHELLE, ou -1. */
  function rang(s) {
    const t = String(s == null ? '' : s).toLowerCase().replace(/[^0-9a-c+]/g, '');
    return ECHELLE.indexOf(t);
  }

  /* Cotation globale, telle que la Norme FFME de décembre 2023 l'énumère :
     F, PD, AD, D, TD, ED, ABO — ABO compris, contrairement à ce qu'on lit
     souvent, et pondérable par + et −. */
  const GLOBALE = [
    ['F', 'Facile'], ['PD', 'Peu difficile'], ['AD', 'Assez difficile'], ['D', 'Difficile'],
    ['TD', 'Très difficile'], ['ED', 'Extrêmement difficile'], ['ABO', 'Abominable'],
  ];
  const rangGlobal = s => {
    const t = String(s == null ? '' : s).toUpperCase().replace(/[^A-Z]/g, '');
    for (let i = GLOBALE.length - 1; i >= 0; i--) if (t.indexOf(GLOBALE[i][0]) === 0) return i;
    return -1;
  };

  function stats(p, items, y) {
    const it = (items || []).filter(x => x && String(x[0] || '').trim());
    if (!it.length) return '';
    const x0 = 54, w = (PW - 2*x0) / it.length;
    let s = `<line x1="${x0}" y1="${y-34}" x2="${PW-x0}" y2="${y-34}" stroke="${p.line}" stroke-width="1.5"/>`;
    it.forEach((c, i) => {
      const cc = x0 + w*i + w/2;
      if (i) s += `<line x1="${(x0+w*i).toFixed(0)}" y1="${y-14}" x2="${(x0+w*i).toFixed(0)}" y2="${y+34}" stroke="${p.line}" stroke-width="1.5"/>`;
      s += T(cc, y+6, fit(c[0], w-24, 36, 0.56, 0, 15), p.ink, esc(c[0]), { f:'Oswald', w:700 })
        + T(cc, y+30, 12, p.muted, esc(up(c[1])), { w:600, ls:2.5 });
    });
    return s;
  }
  function troisValeurs(p, data, y, defaut) {
    const perso = [1, 2, 3].map(i => {
      const raw = String(data['s' + i] || '').trim(); if (!raw) return null;
      const [v, l] = raw.split('|').map(s => (s || '').trim());
      return v ? [v, l || ''] : null;
    });
    return stats(p, perso.some(Boolean) ? perso.filter(Boolean) : (defaut || []), y);
  }

  /* ---------------------------------------------------------------
     LA TOPO. Les longueurs sont empilées du sol au sommet, chacune à sa
     HAUTEUR RÉELLE : une longueur de 50 m est deux fois plus haute qu'une de
     25 m sur le dessin. C'est ce qui fait qu'un grimpeur reconnaît sa voie —
     une topo aux longueurs égales ne raconte rien.
     --------------------------------------------------------------- */
  function topo(cx, yBas, hauteur, l, p) {
    const total = l.reduce((a, x) => a + x.m, 0) || 1;
    const s = hauteur / total;
    const xr = cx - 44;                       /* axe de la voie */
    let g = '';

    /* LA PAROI. Son bord dentelé longe la voie de tout près : c'est là que le
       grimpeur est. Dessinée en retrait, elle se lisait comme un objet
       indépendant posé à côté du tracé.
       Le dentelé est DÉTERMINISTE (suite du nombre d'or) — la même voie
       redonne toujours exactement la même paroi, aperçu comme impression. */
    const xBord = xr - 42;
    const n = 26;
    const crete = [];
    for (let i = 0; i <= n; i++) {
      const t = i / n, y = yBas - hauteur * t;
      const d = ((i * 0.6180339887) % 1) * 24 + ((i * 0.3547) % 1) * 12;
      crete.push([xBord + d, y]);
    }
    const bord = `M ${MX} ${yBas.toFixed(1)} ` + crete.map(c => `L ${c[0].toFixed(1)} ${c[1].toFixed(1)}`).join(' ')
      + ` L ${MX} ${(yBas - hauteur).toFixed(1)} Z`;
    g += `<path d="${bord}" fill="${p.roche}"/>`
      + `<path d="M ${crete.map(c => `${c[0].toFixed(1)} ${c[1].toFixed(1)}`).join(' L ')}" fill="none" stroke="${p.muted}" stroke-width="1.4" opacity="0.7"/>`;

    /* Le sol, puis la voie relais par relais. */
    g += `<line x1="${MX}" y1="${yBas.toFixed(1)}" x2="${(PW - MX).toFixed(1)}" y2="${yBas.toFixed(1)}" stroke="${p.muted}" stroke-width="2"/>`;
    let y = yBas;
    l.forEach((lg, i) => {
      const h = lg.m * s, yHaut = y - h;
      /* la voie serpente : décalage déterministe, jamais aléatoire */
      const dx = ((i % 2) ? 16 : -16) * (0.6 + ((i * 0.618) % 1) * 0.8);
      g += `<path d="M ${xr.toFixed(1)} ${y.toFixed(1)} Q ${(xr + dx).toFixed(1)} ${(y - h/2).toFixed(1)} ${xr.toFixed(1)} ${yHaut.toFixed(1)}"`
        + ` fill="none" stroke="${p.accent}" stroke-width="3" stroke-linecap="round"/>`;
      /* le relais */
      g += `<line x1="${(xr - 13).toFixed(1)}" y1="${yHaut.toFixed(1)}" x2="${(xr + 13).toFixed(1)}" y2="${yHaut.toFixed(1)}" stroke="${p.ink}" stroke-width="2.5"/>`
        + `<circle cx="${xr.toFixed(1)}" cy="${yHaut.toFixed(1)}" r="5.5" fill="${p.bg}" stroke="${p.ink}" stroke-width="2.5"/>`;
      /* la cotation et la longueur, à droite */
      const ym = y - h / 2;
      g += T(xr + 34, ym + 2, Math.min(30, Math.max(15, h * 0.42)), p.ink, esc(lg.cot), { f:'Oswald', w:700, a:'start' })
        + T(xr + 34, ym + 20, 12, p.muted, `${lg.m} M${lg.nom ? ' · ' + esc(up(lg.nom)) : ''}`, { w:600, ls:1.6, a:'start' });
      y = yHaut;
    });
    /* le sommet */
    g += `<circle cx="${xr.toFixed(1)}" cy="${y.toFixed(1)}" r="8" fill="${p.accent}"/>`;
    return g;
  }

  /* Filigrane : un mousqueton. Il ne tenait pas comme sujet principal — tous
     les grimpeurs ont le même — mais en fond il dit « escalade » en un coup
     d'œil, ce qu'aucune liste de cotations ne fait. */
  function filigrane(p) {
    const cx = 400, cy = 566, h = 396, w = 246, ep = 27;
    const d = `M ${cx + 44} ${(cy - h / 2).toFixed(1)} Q ${(cx - w * 0.5).toFixed(1)} ${(cy - h / 2).toFixed(1)} ${(cx - w * 0.5).toFixed(1)} ${(cy - h * 0.28).toFixed(1)}`
      + ` L ${(cx - w * 0.5).toFixed(1)} ${(cy + h * 0.26).toFixed(1)} Q ${(cx - w * 0.5).toFixed(1)} ${(cy + h / 2).toFixed(1)} ${(cx - w * 0.16).toFixed(1)} ${(cy + h / 2).toFixed(1)}`
      + ` L ${(cx + w * 0.16).toFixed(1)} ${(cy + h / 2).toFixed(1)} Q ${(cx + w * 0.5).toFixed(1)} ${(cy + h / 2).toFixed(1)} ${(cx + w * 0.5).toFixed(1)} ${(cy + h * 0.26).toFixed(1)}`
      + ` L ${(cx + w * 0.5).toFixed(1)} ${(cy - h * 0.10).toFixed(1)}`;
    return `<g opacity="0.055"><path d="${d}" fill="none" stroke="${p.ink}" stroke-width="${ep}" stroke-linecap="round" stroke-linejoin="round"/>`
      + `<line x1="${(cx + w * 0.5).toFixed(1)}" y1="${(cy - h * 0.10).toFixed(1)}" x2="${cx + 44}" y2="${(cy - h / 2).toFixed(1)}" stroke="${p.ink}" stroke-width="${(ep * 0.8).toFixed(1)}" stroke-linecap="round"/></g>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.calcaire;
    const mode = String(data.mode || 'voie').toLowerCase();
    const cx = PW / 2;

    const DEF = { voie: 'LA VOIE', croix: 'MES CROIX', progression: 'MA PROGRESSION', bloc: 'LE BLOC', course: 'LA COURSE' };
    const titre = up(data.titre) || DEF[mode] || 'LA VOIE';
    const ts = fit(titre, 690, 74, 0.54, 2, 34);
    const kicker = up(data.kicker) || up(data.club) || 'ESCALADE';
    const sous = [up(data.club), up(data.lieu)].filter(Boolean).join(' · ');

    let corps = '', barre = '', pied = 0;

    if (mode === 'voie') {
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['p' + i] || '').trim(); if (!raw) continue;
        const c = raw.split('|').map(x => (x || '').trim());
        const m = num(c[0]);
        if (m && m > 0) l.push({ m: Math.round(m), cot: c[1] || '', nom: c[2] || '' });
      }
      if (l.length) {
        corps = topo(cx, 880, 560, l, p);
        const total = l.reduce((a, x) => a + x.m, 0);
        const durs = l.map(x => rang(x.cot)).filter(r => r >= 0);
        barre = stats(p, [[String(l.length), l.length > 1 ? 'Longueurs' : 'Longueur'], [total + ' m', 'Hauteur'],
          [durs.length ? ECHELLE[Math.max.apply(null, durs)] : '—', 'Le pas le plus dur']], 962);
      } else corps = T(cx, 600, 19, p.muted, 'FORMAT : LES MÈTRES, LA COTATION, LE NOM DE LA LONGUEUR', { w:600, ls:1.4 });
      pied = 1030;

    } else if (mode === 'croix') {
      const l = [];
      for (let i = 1; i <= 8; i++) {
        const raw = String(data['c' + i] || '').trim(); if (!raw) continue;
        const c = raw.split('|').map(x => (x || '').trim());
        if (c[0]) l.push(c);
      }
      if (l.length) {
        const zone = 620, pas = Math.min(102, zone / l.length), y0 = 340 + (zone - pas*l.length) / 2;
        l.forEach((r, i) => {
          const y = y0 + i * pas, avue = /^(à vue|a vue|avue|flash)/i.test(r[2] || '');
          corps += T(MX, y - 12, 13, p.muted, esc(up(r[3] || '')), { w:600, ls:2, a:'start' })
            + T(MX, y + 16, fit(r[0], 430, 26, 0.60, 0, 14), p.ink, esc(r[0]), { f:'Oswald', w:700, a:'start' })
            + (r[1] ? T(PW - MX - 96, y + 16, 30, p.accent, esc(r[1]), { f:'Oswald', w:700, a:'end' }) : '')
            + (r[2] ? T(PW - MX, y + 14, 16, avue ? p.accent : p.muted, esc(up(r[2])), { f:'Oswald', w:700, a:'end' }) : '');
          if (i < l.length - 1) corps += `<line x1="${MX}" y1="${(y + pas/2 - 7).toFixed(1)}" x2="${PW-MX}" y2="${(y + pas/2 - 7).toFixed(1)}" stroke="${p.line}" stroke-width="1.5"/>`;
        });
      } else corps = T(cx, 600, 19, p.muted, 'FORMAT : LA VOIE, LA COTATION, LE STYLE, LE SITE', { w:600, ls:1.6 });
      pied = 1000;

    } else if (mode === 'progression') {
      const v = [];
      for (let i = 1; i <= 10; i++) {
        const raw = String(data['r' + i] || '').trim(); if (!raw) continue;
        const [an, cot] = raw.split('|').map(x => (x || '').trim());
        const r = rang(cot);
        if (r >= 0) v.push({ an, r, cot: ECHELLE[r] });
      }
      if (v.length >= 2) {
        const X0 = MX + 54, X1 = PW - MX - 12, Y0 = 330, Y1 = 830;
        const lo = Math.min.apply(null, v.map(x => x.r)), hi = Math.max.apply(null, v.map(x => x.r));
        const bas = Math.max(0, lo - 1), haut = Math.min(ECHELLE.length - 1, hi + 1);
        const py = r => Y1 - (Y1 - Y0) * (r - bas) / Math.max(1, haut - bas);
        const px = i => X0 + (X1 - X0) * i / Math.max(1, v.length - 1);
        /* L'AXE DES COTATIONS est l'échelle française elle-même : un cran =
           un échelon réel, pas une graduation régulière inventée. */
        for (let r = bas; r <= haut; r++) {
          const y = py(r);
          corps += `<line x1="${X0 - 8}" y1="${y.toFixed(1)}" x2="${X1}" y2="${y.toFixed(1)}" stroke="${p.line}" stroke-width="1.2"/>`
            + T(X0 - 16, y + 5, 13, p.muted, ECHELLE[r], { f:'Oswald', w:700, a:'end' });
        }
        corps += `<polyline points="${v.map((x, i) => `${px(i).toFixed(1)},${py(x.r).toFixed(1)}`).join(' ')}" fill="none" stroke="${p.accent}" stroke-width="3.5" stroke-linejoin="round" stroke-linecap="round"/>`;
        v.forEach((x, i) => {
          const dernier = i === v.length - 1;
          corps += `<circle cx="${px(i).toFixed(1)}" cy="${py(x.r).toFixed(1)}" r="${dernier ? 8 : 5}" fill="${dernier ? p.accent : p.bg}" stroke="${p.accent}" stroke-width="2.5"/>`
            + (x.an ? T(px(i), Y1 + 26, 12, p.muted, esc(up(x.an)), { w:600, ls:1.2 }) : '');
        });
        barre = stats(p, [[ECHELLE[hi], 'Meilleure cotation'], [String(v.length), 'Relevés'],
          [(hi - v[0].r >= 0 ? '+' : '') + (hi - v[0].r), 'Crans gagnés']], 962);
      } else corps = T(cx, 600, 19, p.muted, 'DEUX COTATIONS SUFFISENT POUR TRACER LA COURBE', { w:600, ls:1.8 });
      pied = 1030;

    } else if (mode === 'bloc') {
      /* Le bloc : la cotation en très grand, et le nombre de séances en
         bâtons — c'est le vrai récit d'un projet de bloc. */
      const cot = String(data.cotation || '').trim();
      const seances = Math.max(0, Math.min(40, parseInt(String(data.seances || ''), 10) || 0));
      /* silhouette de bloc, déterministe */
      const bx = cx, by = 470, bw = 210, bh = 150;
      let blocPath = `M ${(bx - bw/2).toFixed(1)} ${(by + bh/2).toFixed(1)}`;
      const pts = [[-0.46, 0.10], [-0.38, -0.24], [-0.16, -0.44], [0.10, -0.50], [0.34, -0.36], [0.47, -0.06], [0.50, 0.28]];
      for (const [fx, fy] of pts) blocPath += ` L ${(bx + fx*bw).toFixed(1)} ${(by + fy*bh).toFixed(1)}`;
      blocPath += ` L ${(bx + bw/2).toFixed(1)} ${(by + bh/2).toFixed(1)} Z`;
      corps = `<path d="${blocPath}" fill="${p.roche}" stroke="${p.muted}" stroke-width="2" stroke-linejoin="round"/>`;
      corps += T(cx, 620, fit(cot || '—', 560, 132, 0.56, 0, 40), p.accent, esc(cot) || '—', { f:'Oswald', w:700 });
      if (seances) {
        const y = 700, pasX = Math.min(24, 520 / seances), x0 = cx - (seances - 1) * pasX / 2;
        for (let i = 0; i < seances; i++)
          corps += `<line x1="${(x0 + i*pasX).toFixed(1)}" y1="${y}" x2="${(x0 + i*pasX).toFixed(1)}" y2="${y + 26}" stroke="${p.ink}" stroke-width="3" stroke-linecap="round"/>`;
        corps += T(cx, y + 50, 12, p.muted, seances > 1 ? `${seances} SÉANCES SUR LE BLOC` : 'UNE SÉANCE SUR LE BLOC', { w:600, ls:3 });
      }
      barre = troisValeurs(p, data, 962, [[esc(String(data.spot || '').trim()) || '—', 'Le bloc'],
        [esc(String(data.essais || '').trim()) || '—', 'Essais'], [cot || '—', 'Cotation']]);
      pied = 1030;

    } else { /* course */
      const ri = rangGlobal(data.globale);
      const X = MX + 30, Y0 = 306, Y1 = 646, pas = (Y1 - Y0) / (GLOBALE.length - 1);
      corps = `<line x1="${X}" y1="${Y0}" x2="${X}" y2="${Y1}" stroke="${p.line}" stroke-width="2"/>`;
      GLOBALE.forEach(([code, nom], i) => {
        const y = Y1 - i * pas, actif = i === ri;
        corps += `<circle cx="${X}" cy="${y.toFixed(1)}" r="${actif ? 9 : 5}" fill="${actif ? p.accent : p.bg}" stroke="${actif ? p.accent : p.muted}" stroke-width="2.5"/>`
          + T(X + 26, y + 6, actif ? 26 : 17, actif ? p.ink : p.muted, code, { f:'Oswald', w:700, a:'start' })
          + T(X + 92, y + 5, 12, p.muted, up(nom), { w:600, ls:1.6, a:'start' });
      });
      corps += T(X, Y0 - 30, 11, p.muted, 'COTATION GLOBALE', { w:600, ls:3, a:'start' });
      const l = [];
      for (let i = 1; i <= 6; i++) {
        const raw = String(data['l' + i] || '').trim(); if (!raw) continue;
        const [lab, v] = raw.split('|').map(x => (x || '').trim());
        if (lab && v) l.push([lab, v]);
      }
      if (l.length) {
        /* Le pas est BORNÉ PAR LA HAUTEUR DISPONIBLE, pas seulement par un
           maximum : six lignes à 52 px poussaient la dernière sous la barre
           de valeurs, où elle se superposait à la graduation. */
        const y0 = 702, dispo = 902 - y0, pasL = Math.min(46, dispo / Math.max(1, l.length - 1 || 1));
        l.forEach((r, i) => {
          const y = y0 + i * pasL;
          corps += T(MX, y, 13, p.muted, esc(up(r[0])), { w:600, ls:2.2, a:'start' })
            + T(PW - MX, y + 4, fit(r[1], 380, 24, 0.58, 0, 13), p.ink, esc(r[1]), { f:'Oswald', w:700, a:'end' });
          if (i < l.length - 1) corps += `<line x1="${MX}" y1="${(y + pasL/2 - 5).toFixed(1)}" x2="${PW-MX}" y2="${(y + pasL/2 - 5).toFixed(1)}" stroke="${p.line}" stroke-width="1.2"/>`;
        });
      }
      barre = stats(p, [[esc(String(data.sommet || '').trim()) || '—', 'Sommet'],
        [esc(String(data.denivele || '').trim()) || '—', 'Dénivelé'],
        [ri >= 0 ? GLOBALE[ri][0] : (esc(String(data.globale || '').trim()) || '—'), 'Cotation globale']], 966);
      pied = 1032;
    }

    /* Le filigrane n'est posé que sur les modes où la place est vraiment
       vide : là où un dessin occupe déjà l'affiche, il ne ferait que salir. */
    const fili = ["croix","progression","bloc","course"].indexOf(mode) >= 0 ? filigrane(p) : '';
    const bas = [esc(up(data.joueur)), esc(up(data.equipe))].filter(Boolean).join(' · ');
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
${T(cx, 84, 19, p.accent, esc(kicker), { w:700, ls:5 })}
${T(cx, 168, ts, p.ink, esc(titre), { f:'Oswald', w:700, ls:2 })}
${sous ? T(cx, 204, fit(sous, 660, 17, 0.66, 3.5, 11), p.muted, esc(sous), { w:600, ls:3.5 }) : ''}
${fili}
${corps}
${barre}
${pied && bas ? T(cx, pied, fit(bas, 690, 19, 0.60, 1, 12), p.ink, bas, { f:'Oswald', w:700, ls:1 }) : ''}
</svg>`;
  }

  window.SNEsTopo = { render, PALETTES, ECHELLE, GLOBALE };
})();
